import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, ValidationErrors } from '@angular/forms';

/** ENF-2488 — shown instead of the API's "Unauthorized" when a TFM review call is rejected for permissions. */
export const TFM_FORBIDDEN_MESSAGE = 'No tienes permiso para realizar esta acción.';

export const TFM_GRADE_ERROR_MESSAGE = 'Introduce una nota entre 0,0 y 10,0 con un único decimal.';

/** A number with at most one decimal, written with a dot or a comma — the same rule the API applies. */
const ONE_DECIMAL_GRADE = /^\d{1,2}([.,]\d)?$/;

/** The toast text for a failed TFM review call: the permission message on 401/403, the given fallback otherwise. */
export const tfmErrorMessage = (error: unknown, fallback: string): string => {
  const status = error instanceof HttpErrorResponse ? error.status : (error as { status?: number } | null)?.status;
  return status === 401 || status === 403 ? TFM_FORBIDDEN_MESSAGE : fallback;
};

/** Grades go from 0,0 to 10,0 with a single decimal (min/max are checked by their own validators). */
export const oneDecimalGradeValidator = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (value === null || value === undefined || value === '') return null;
  return ONE_DECIMAL_GRADE.test(String(value).trim()) ? null : { oneDecimal: true };
};
